export type VehicleIdSource =
  | string
  | number
  | null
  | undefined
  | Record<string, unknown>
  | Array<unknown>;

const asNonEmptyString = (value: unknown): string | null => {
  if (typeof value === "number" && Number.isFinite(value)) {
    return String(value);
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    return trimmed.length ? trimmed : null;
  }

  return null;
};

export const normalizeVehicleId = (source: VehicleIdSource): string | null => {
  if (Array.isArray(source)) {
    return source.length ? normalizeVehicleId(source[0]) : null;
  }

  const direct = asNonEmptyString(source);
  if (direct) return direct;

  if (!source || typeof source !== "object") return null;

  const objectSource = source as Record<string, unknown>;
  const candidate =
    objectSource.vehicle_id ??
    objectSource.vehicleId ??
    objectSource.id ??
    objectSource.uuid ??
    objectSource.announcementId;

  return asNonEmptyString(candidate);
};

export const toMetaContentIds = (vehicleId: VehicleIdSource): string[] | null => {
  const normalized = normalizeVehicleId(vehicleId);
  return normalized ? [normalized] : null;
};

